<template>
  <div id="monitorManagement">
    <el-container class="monitorManagement">
      <el-card class="tabs-card">
        <el-form :inline="true" class="demo-form-inline">
          <div class="tabs-card-header">
            <el-form-item>
              <h-button plain type="primary" @click="steps">新建</h-button>
              <h-button
                plain
                type="danger"
                @click="del"
                :disabled="delList.length === 0"
                >删除</h-button
              >
              <h-button plain :disabled="bkList.length === 0">布控</h-button>
              <h-button plain :disabled="csList.length === 0">撤控</h-button>
              <h-button plain type="primary" @click="infodownloadAxios"
                >导出</h-button
              >
              <h-button type="primary" @click="refreshTable">查询</h-button>
            </el-form-item>

            <el-form-item>
              <el-input
                v-model="tableParams.search"
                placeholder="布控名称/布控人"
              >
                <template #suffix>
                  <div @click="refreshTable" style="cursor: pointer">
                    <el-icon>
                      <Search></Search>
                    </el-icon>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <el-card class="table-box">
        <el-form :inline="true" ref="formRef" :model="tableParams">
          <el-form-item label="状态" prop="status">
            <el-select v-model="tableParams.status" placeholder="状态">
              <el-option
                v-for="it in statusList"
                :key="it.code"
                :label="it.value"
                :value="it.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="布控维度" prop="nodeId">
            <el-select v-model="tableParams.nodeId" placeholder="布控维度">
              <el-option
                v-for="it in nodeIdList"
                :key="it.nodeId"
                :label="it.nodeName"
                :value="it.nodeId"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="布控时间">
            <h-date-timerange
              v-model:end="tableParams.endTime"
              v-model:start="tableParams.beginTime"
              type="daterange"
              :shortcutsActive="true"
              :clearable="false"
            >
            </h-date-timerange>
          </el-form-item>
        </el-form>
        <h-table
          ref="tableRef"
          v-model:columns="columns"
          :method="infopage"
          :params="tableParams"
          @select="hzTableSelect"
        >
          <template #beginMills="{ row }">
            {{ formatDateHMSSJC(row.beginMills) }} ~
            {{ formatDateHMSSJC(row.endMills) }}
          </template>
          <template #createTime="{ row }">
            {{ formatDateHMSSJC(row.createTime) }}
          </template>
          <template #dispositionAlarmNum="{ row }">
            {{ row.dispositionAlarmNum }}
          </template>
          <template #target="{ row }">
            <img
              v-if="row.target.imgUrl"
              :src="url + row.target.imgUrl"
              style="width: 100px; height: 80px"
              alt=""
            />
            <h-car-plate
              class="plateNo"
              v-if="row.target.plateInfoVOList"
              :colorData="colorDict"
              :type="row.target.plateInfoVOList.plateColor"
            >
              {{ row.target.plateInfoVOList.plateNo }}
            </h-car-plate>
            <span v-if="row.target.tabInfoList">
              {{
                row.target.tabInfoList
                  .map((item) => {
                    return item.tabName;
                  })
                  .toString()
              }}
            </span>
          </template>
          <template #buildRegionList="{ row }">
            <h-button
              type="primary"
              plain
              size="small"
              v-if="row.status === '2'"
              @click="bcClick(1, row, '布控')"
              >布控</h-button
            >
            <h-button
              type="primary"
              plain
              size="small"
              v-else
              @click="bcClick(2, row, '撤控')"
              >撤控</h-button
            >
            <h-button type="danger" plain size="small" @click="del(row)"
              >删除</h-button
            >
          </template>
        </h-table>
      </el-card>
    </el-container>
    <el-dialog title="布控" v-model="flag" width="60%" v-if="flag">
      <el-container>
        <el-container>
          <firstStep
            :regionIdListData="regionIdListData"
            @eventFlag="hidden"
            @refresh="refreshTable"
          ></firstStep>
        </el-container>
        <!-- <el-card>
          <el-aside width="280px">操作记录</el-aside>
        </el-card> -->
      </el-container>
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  watch,
  watchEffect,
} from "vue";
// import { ElMessageBox, ElMessage, FormInstance } from "element-plus";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  infopage,
  infoonoff,
  dispositionDelete,
  infodownload,
  treenodes,
} from "@/api/monitorManagement/monitorManagementApi.js";
import { Check, Search } from "@element-plus/icons-vue";
import firstStep from "@/views/monitorManagement/components/firstStep.vue";
import { useRouter } from "vue-router";
import { formatDateHMSSJC, formatDateHMS } from "@/utils/index.js";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "monitorManagement",
  components: {
    firstStep,
    Search,
  },
  props: {},
  setup(props) {
    const state = reactive({
      url: window.imgHZURL,
      componentId: "firstStep",
      Time: [],
      active: 0,
      flag: false,
      bkList: [],
      csList: [],
      delList: [],
      tableParams: {
        beginTime: formatDateHMS(new Date().getTime() - 24 * 3600 * 1000 * 30),
        endTime: formatDateHMS(new Date()),
        search: "",
        status: "",
        nodeId: "",
      },
      columns: [
        { type: "selection" },
        { type: "index" },
        {
          label: "状态",
          prop: "statusDesc",
        },
        {
          label: "布控名称",
          prop: "name",
        },
        // {
        //   label: "上下级域",
        //   prop: "telphone",
        // },
        {
          label: "布控时段",
          slot: "beginMills",
          width: 400,
        },
        {
          label: "布控目标",
          slot: "target",
        },
        // {
        //   label: "布控人",
        //   prop: "applicantName",
        // },
        {
          label: "创建时间",
          slot: "createTime",
        },
        // {
        //   label: "警告",
        //   slot: "dispositionAlarmNum",
        // },
        {
          label: "操作",
          slot: "buildRegionList",
        },
        // {
        //   operates: [
        //     { name: "撤控", emitKey: "edit" },
        //     { name: "删除", emitKey: "del", type: "danger" },
        //   ],
        // },
      ],
      regionIdListData: [], //路由传过来的设备ID数组
      statusList: [], //数据字典
      nodeIdList: [], //数据字典
      regionIdsList: [], //数据字典
    });
    const tableRef = ref(null);
    const formRef = ref(null);

    const router = useRouter();
    watchEffect(() => {
      if (router.currentRoute.value.query.deviceArray) {
        state.regionIdListData = router.currentRoute.value.query.deviceArray;
        nextTick(() => {
          steps();
        });
      }
    });
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const steps = () => {
      state.flag = !state.flag;
    };
    const hidden = (e) => {
      state.flag = e;
    };
    const codeAxios = async () => {
      const res = await getDict("zghz-disposition-status");
      const nodeId = await treenodes();
      let obj = [
        {
          value: "不限",
          code: "",
        },
      ];
      state.statusList = [...obj, ...res.dict];
      state.nodeIdList = nodeId.list.filter((item) => {
        if (item.enableConfig) return item;
      });
      state.nodeIdList = [
        {
          nodeName: "不限",
          nodeId: "",
        },
      ].concat(state.nodeIdList);
    };
    codeAxios();

    const hzTableSelect = (val) => {
      // 布控
      state.bkList = val.filter((item) => {
        if (item.status === "2") {
          return item;
        }
      });
      // 撤控
      state.csList = val.filter((item) => {
        if (item.status === "1") {
          return item;
        }
      });
      // 删除
      state.delList = val;
    };
    // 布控 撤控
    // infoonoff
    const bcClick = async (is, item, text) => {
      ElMessageBox.confirm(
        `确定${text}所选任务吗？`,
        `确定${text}所选任务吗？`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          const params = {
            ids: item.id,
            type: is,
          };
          if (item) {
            params.ids = [item.id];
          } else {
            if (is === 1) {
              params.taskIds = state.tableCheckks.map((item) => item.id);
            } else {
              params.taskIds = state.tableCheckzt.map((item) => item.id);
            }
          }
          const res = await infoonoff(params);
          if (res.code === 0) {
            refreshTable();
            ElMessage({
              type: "success",
              message: text + "成功",
            });
          }
        },
        () => {}
      );
    };
    const del = (row) => {
      ElMessageBox.confirm(`确定删除所选任务吗？`, `确定删除所选任务吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let params = {};
          if (row) {
            params.ids = [row.id];
          } else {
            params.ids = state.delList.map((item) => item.id);
          }
          const res = await dispositionDelete(params);
          if (res.code === 0) {
            refreshTable();
            ElMessage({
              type: "success",
              message: "删除成功",
            });
          }
        },
        () => {}
      );
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    const infodownloadAxios = async () => {
      const res = await infodownload({});
      // const fileName = `5666.xls`;
      // const blob = new Blob([res], {
      //   type: "application/vnd.ms-excel;charset=utf-8"
      // });
      const fileName = `${+new Date()}.zip`;
      const blob = new Blob([res], {
        type: "application/octet-stram",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    return {
      ...toRefs(state),
      hidden,
      infodownloadAxios,
      del,
      refreshTable,
      tableRef,
      resetForm,
      formRef,
      hzTableSelect,
      Check,
      steps,
      infopage,
      formatDateHMSSJC,
      bcClick,
    };
  },
});
</script>
<style lang="scss" scoped>
#monitorManagement {
  position: relative;
  .monitorManagement {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .tabs-card {
      height: 80px;
      .tabs-card-header {
        display: flex;
        justify-content: space-between;
      }
    }
    .table-box {
      flex: 1;
      .el-form {
        display: flex;
        // /deep/ .el-input__inner {
        //   margin-right: 12px;
        // }
      }
      /deep/ .el-loading-mask {
        display: none;
      }
    }
  }
  #mask {
    z-index: 100;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .el-container {
      height: 80%;
    }
    .el-header {
      height: 60px;
      display: flex;
      align-items: center;
      .el-card {
        width: 100%;
        .el-form {
          .el-form-item {
            .el-form-item__content {
            }
          }
        }
      }
    }
    // .el-main {
    //   .el-card {
    //     width: 100%;
    //     margin-bottom: 10px;
    //     :deep(.el-form) {
    //       // .el-form-item {
    //       //   .el-form-item__content {
    //       //     .time {
    //       //       width: 100% !important;
    //       //     }
    //       //   }
    //       // }
    //     }
    //   }
    // }
  }
}
</style>
